import { MapPinIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"
import { CreateRouteWizard } from "../../components/delivery-routes/create-wizard"

export function DeliveryRouteNewPage() {
  const { t } = useTranslation(["delivery", "common"])
  const ROUTE_PLAN = usePermission("DEL_ROUTE_PLAN")
  const breadcrumbs = useBreadcrumb(t)

  return (
    <PageLayout
      icon={<MapPinIcon size={22} />}
      title={t("delivery:route.wizard.title")}
      subTitle={t("delivery:route.wizard.subtitle")}
      breadcrumb={breadcrumbs}
    >
      {ROUTE_PLAN.hasAccess ? <CreateRouteWizard /> : ROUTE_PLAN.accessDenied()}
    </PageLayout>
  )
}

const useBreadcrumb = (t: (key: string) => string) => [
  { to: "/", label: t("common:breadcrumb.home") },
  { to: "/delivery-routes", label: t("delivery:route.title") },
  { label: t("delivery:route.wizard.crumb") },
]
